currentView